import type { ElectronClient } from '@openphone/desktop-client'
import {
  UserMediaDevicePlatformError,
  isUserMediaDevicePlatformError,
} from '@openphone/desktop-client'

import UMDAPlatformStrategy from './UMDAPlatformStrategy'

export default class UMDAElectronStrategy extends UMDAPlatformStrategy {
  constructor(private readonly electronClient: ElectronClient) {
    super(electronClient.platform)
  }

  async hasMicrophoneAccess() {
    const status = await this.electronClient.app?.hasMicrophoneAccess?.()
    if (isUserMediaDevicePlatformError(status)) {
      return status
    }

    if (!status) {
      return new UserMediaDevicePlatformError({
        mediaDevice: 'microphone',
        platform: this.electronClient.platform,
        originalError: new Error('Failed to check microphone access'),
      })
    }

    return status
  }
}
